import { pass, skip } from "../buildResult";
import { defineTest } from "../defineTest";
import {
  getChartHistoryFieldCount,
  isChartHistoryPresent,
} from "../../chartHistoryUtils";

export default defineTest("chart_history", "Chart history", ({ patient }) => {
  if (!patient?.patient_id) return skip("No patient record");

  if (!isChartHistoryPresent(patient.chart_history)) {
    return skip("No chart history (optional for this patient)");
  }

  const fieldCount = getChartHistoryFieldCount(patient.chart_history);
  return pass(
    `Chart history present (${fieldCount} field${fieldCount === 1 ? "" : "s"})`
  );
});
